import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import ListInquiry from "../../components/ListInquiry";
import Grid from '@mui/material/Grid';
import "./style.css";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import Post from "../../pages/PIList/Post.jsx";
import {useNavigate} from "react-router-dom";
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';

export default function CreatePost(){

    const [Caption,setCaption] = useState("")
    const [skip, setSkip] = useState(0)
    const [searchThis, setsearchThis] = useState("billTo")
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const navigate = useNavigate();
    const [query,setQuery] = useState("")
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
   

    useEffect(() => {
        fetchPosts();
    }, [skip,query]);

    async function newPI(e){
        history("/proformainvoice",{state:{stuff:"new"}})

    }

    const nowstate = useSelector(state => state);


    const fetchPosts = async () => {
        if(query.trim()){
                try{
                    const { data, error } = await read(skip,query,searchThis);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                }
            
        }else{

        try{
            const { data, error } = await readEmpty(skip,nowstate.user.sales);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data])
        }catch(error){
            console.log(error.message);
        } 
        }
    }

    const [fileURL, setFileURL] = useState("");


    const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const currid = post._id
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/previewpdf?currid=${currid}&dbwhatToPreview=proformainvoiceDB`,{
            method: "GET",
            responseType: "blob"
        }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const newFetchPosts = async (event) => {
        setPosts([])
        setIsEnd("Loading...");
        if(event.target.value.trim()){
        try{
            const { data, error } = await read(skip,event.target.value,searchThis);
            if(error){
                console.log(error.message);
                return;
            }

            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...data])
        }catch(error){
            console.log(error.message);
        }
        }else{
            console.log("empty")
            try{
                const { data, error } = await readEmpty(skip,nowstate.user.sales);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            } 
        }
    }

    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;

        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
    }

    const searchSelected = async (event)=>{
        setsearchThis(event.target.value)
        if(query.trim()){
            try{
                const { data, error } = await read(skip,query,event.target.value);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...data])
            }catch(error){
                console.log(error.message);
            }
            }else{
                console.log("empty")
                try{
                    const { data, error } = await readEmpty(skip,query);
                    if(error){
                        console.log(error.message);
                        return;
                    }
        
                    if(data?.length === 0){
                        setIsEnd("Selesai...");
                        return;
                    }
                    
                    //success
                    setPosts([...posts, ...data])
                }catch(error){
                    console.log(error.message);
                } 
            }
    }
    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }

    const handleClosePreview = (event) =>{
        setPreviewVisibility(false)
        setCurrPreview("none")
    }
    const history = useNavigate();

    const editPI = async (post) => {
        if(currPreview === "none"){
            history("/proformainvoice",{state:{data:post, stuff:"edit"}})
        }else{
            history("/proformainvoice",{state:{data:currPreview, stuff:"edit"}})
        }
    }

    const addonPI = async (post)=>{
        if(currPreview === "none"){
            history("/proformainvoice", {state:{data:post,stuff:"addOn"}})
        }else{
            history("/proformainvoice", {state:{data:currPreview,stuff:"addOn"}})
        }
    }

    const [openPickInquiry, setOpenPickInquiry] = useState(false)
    const pickInquiry = () => {
        setOpenPickInquiry(true)
    }

    const closeOpenPickInquiry = () => {
        setOpenPickInquiry(false)
    }

    const kliensudahBayar = () => {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updatePIOneWhatever`, {
            isi: "Drop", piAmount:currPreview.piAmount, updateApa:"dropPI"
        }).then(() => {
            window.location.reload(); // refresh the page after successful update
        }).catch(error => {
            // handle error
            console.log(error);
        }); 
    }
    const [openLater, setOpenLater] = useState(false)
    const [tanggalWait,setTanggalWait] = useState(() => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 5);
        return currentDate;
      });
    const waitLater = () => {
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/updatePIOneWhatever`, {
            isi: tanggalWait, piAmount:currPreview.piAmount, updateApa:"waitPIFollowUp"
        }).then(() => {
            window.location.reload(); // refresh the page after successful update
        }).catch(error => {
            // handle error
            console.log(error);
        }); 
}

    return <Grid sx={12} container>
    <Dialog open={openLater} onClose={()=>setOpenLater(false)}>
                    <Grid sx={{p:5}}>
                        Kapan infonya dia akan proses lagi/ kapan kamu mau diingatkan kembali?
                        <Grid xs={12}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={tanggalWait}
                                    onChange={(event)=>setTanggalWait(event)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                                </LocalizationProvider>
</Grid>
                        <Grid sx={{mt:5}}>
                        <Button variant="contained" onClick={()=>waitLater()}>Simpan/Save</Button>
                        </Grid>

                        <Grid sx={{mt:3}}>
                        <Button variant="contained" color="error" onClick={()=>setOpenLater(false)}>Cancel</Button>
                        </Grid>

                    </Grid>

                </Dialog>
                <Dialog open={openPickInquiry} onClose={closeOpenPickInquiry}>
                    <ListInquiry></ListInquiry>
                </Dialog>
                    <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <Grid container>
                        <Grid xs={5}>
                        <iframe src={`${fileURL}#zoom=60`} width="100%" height="500" style={{zoom:"150%"}}/>

                        </Grid>
                        <Grid xs={1}>

                        </Grid>
                        <Grid xs={5}>
                            <Typography variant="h5">Apa yang mau kamu lakukan?</Typography>
                            <Grid xs={12} sx={{mt:5}}>
                            <Button variant="contained" color="success" onClick={()=>setOpenLater(true)}>Ingatkan saya nanti</Button>
                            </Grid>
                            <Grid xs={12} sx={{mt:5}}>
                            <Button variant="contained" onClick={kliensudahBayar}>Drop PI</Button>
                            </Grid>
                            <Grid xs={12} sx={{mt:5}}>
                            <Button variant="contained" color="error" onClick={handleClosePreview}>Cancel</Button>
                            </Grid>
                        </Grid>
                        
                    </Grid>                    
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    </DialogActions>
                </Dialog>
                
                    <Grid container>


                            <Grid container align = "center" justify = "center" alignItems = "center" >
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 250, minHeight: 250 }} style={{ overflow: 'auto',  // Thick Border
      boxShadow: '5px 5px 7px grey'}} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Reminder Belum Pelunasan
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover sx={{
                '&:hover': {
                    backgroundColor: 'rgba(255, 83, 46,1) !important',
                },
                backgroundColor: 'red',
                height:"10px",
            }}>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.billTo} Belum Pelunasan PI: {post.PINumbnow}</p>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>
                            
                            
                    </Grid>
                </Grid>    
    };

